import type { API } from '@editorjs/editorjs';

export const hasChanged = async (api: API) => api.blocks.getBlocksCount() > 0;
